import { loadableWithFallback } from '@vision/ui/utils';
import type { WordCloudChartAtaProps } from './WordCloudChartAta';

export const WordCloudChartAta = loadableWithFallback<WordCloudChartAtaProps>(() => import('./WordCloudChartAta'));
